/**
 * Email Domain Allowlist
 *
 * Only allows signups from trusted, major email providers.
 * This prevents abuse from disposable/temporary email services.
 */

// Allowed email domains (major providers only)
export const ALLOWED_EMAIL_DOMAINS = [
  // Gmail
  'gmail.com',
  'googlemail.com',

  // Microsoft
  'outlook.com',
  'hotmail.com',
  'live.com',
  'msn.com',

  // Yahoo (major regions)
  'yahoo.com',
  'yahoo.co.uk',
  'yahoo.ca',
  'yahoo.com.br',
  'yahoo.fr',
  'yahoo.de',
  'yahoo.es',
  'yahoo.it',
  'yahoo.co.jp',
  'yahoo.com.au',
  'yahoo.in',

  // Apple
  'icloud.com',
  'me.com',
  'mac.com',

  // Privacy-focused
  'protonmail.com',
  'proton.me',
  'tutanota.com',

  // Other major providers
  'aol.com',
  'zoho.com',
  'gmx.com',
  'gmx.net',
  'mail.com',
  'yandex.com',
  'yandex.ru',

  // Add more trusted providers as needed
  `pickstaraitest.com`
];

/**
 * Check if an email address uses an allowed domain
 * @param {string} email - The email address to check
 * @returns {boolean} - True if the email domain is NOT allowed (denied)
 */
export const isEmailDenied = (email) => {
  if (!email || typeof email !== 'string') {
    return false;
  }

  const emailLower = email.toLowerCase().trim();
  const atIndex = emailLower.lastIndexOf('@');

  if (atIndex === -1) {
    return false; // Invalid email format, let Firebase handle it
  }

  const domain = emailLower.substring(atIndex + 1);

  // Return true (denied) if domain is NOT in the allowlist
  return !ALLOWED_EMAIL_DOMAINS.includes(domain);
};
